import { useOmniOfferShowQuery } from "@/services/backend/omni/offer/api/offer-api";
import { OfferDataPage } from "@/services/backend/wrh/offer/components/offer-data-page";
import { CardSkeleton } from "@/shared/components/card-skeleton";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useParams } from "react-router";

export function OfferDataRoute() {
  const { offerId } = useParams();

  const { data, isLoading, error } = useOmniOfferShowQuery({
    id: offerId!,
  });

  return (
    <div>
      {error && <RTKQueryErrorAlert error={error} />}
      {isLoading && <CardSkeleton />}
      {data && <OfferDataPage offer={data} />}
    </div>
  );
}
